import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { LoginRecoveryPath } from '@pages/login-recovery-options/routes/login-recovery-path.enum';
import { ApplicationPath } from '@core/navigation/models/application-path.enum';
import { Router } from '@angular/router';

@Component({
  selector: 'itc-login-recovery-option',
  templateUrl: 'login-recovery-option.component.html',
  styleUrl: 'login-recovery-option.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginRecoveryOptionComponent {
  private readonly router = inject(Router);

  readonly iconClassName = input.required<string>();
  readonly label = input.required<string>();
  readonly loginRecoveryPath = input.required<LoginRecoveryPath>();

  goToRecoveryOptionPage(): void {
    this.router.navigateByUrl(`${ApplicationPath.CannotLogin}/${this.loginRecoveryPath()}`);
  }
}
